<h2>Are you sure?</h2>
<mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="false">Cancel</button>
    <button mat-flat-button color="primary" [mat-dialog-close]="true">Confirm</button>
</mat-dialog-actions>